import { combineReducers } from 'redux';
import authSlice from './authSlice';
import reelsSlice from './reelsSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  reels: reelsSlice
});

export default rootReducer;